export default __webpack_public_path__ + "static/media/expandIcon.f2931ec3.svg";